module.exports = __webpack_public_path__ + "img/lite.d6732fda.jpg";